import { render, staticRenderFns } from "./SpecialBiwako202409.vue?vue&type=template&id=070eec2e&scoped=true"
import script from "./SpecialBiwako202409.vue?vue&type=script&lang=js"
export * from "./SpecialBiwako202409.vue?vue&type=script&lang=js"
import style0 from "./SpecialBiwako202409.vue?vue&type=style&index=0&id=070eec2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070eec2e",
  null
  
)

export default component.exports